<template>
  <a-modal
    class="version"
    title="版本管理"
    :visible="visible"
    :footer="null"
    :bodyStyle="bodyStyle"
    @cancel="hidden"
  >
    <div class="head">
      <div class="nowVersion">当前版本号：v{{ nowVersion }}</div>
      <div class="addButton">
        <a-button @click="addVersion">
          新增版本
        </a-button>
      </div>
    </div>
    <div class="table">
      <div class="row thead">
        <div class="col" v-for="(item, index) in columns" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="row" v-for="(item, index) in data" :key="index">
        <div class="col">
          <div v-if='!item.edit'>
            v{{ item.number }}
          </div>
          <a-input v-else v-model="item.number" placeholder='版本号'/>
        </div>
        <div class="col">
          <div v-if='!item.edit'>
            {{ item.summary }}
          </div>
          <a-textarea v-else v-model='item.summary' placeholder="请输入版本描述" :autosize="{ minRows: 1, maxRows: 3 }" />
        </div>
        <div class="col">
          {{ item.hex_create_time | toTime }}
        </div>
        <div class="col">
          <a-popconfirm
            v-show='!item.edit'
            title="您确定要读取这个版本吗?"
            @confirm="getVersion(item,index)"
            okText="确定"
            cancelText="取消"
          >
            <a-button class="error" type="link">
              取档
            </a-button>
          </a-popconfirm>
          <span class="line" v-show='!item.edit'></span>
          <a-button class="info" type="link" @click='edit(item)'>{{item.edit?'保存':'编辑'}}</a-button>
          <span class="line" v-show='!item.edit'></span>
          <a-popconfirm
            v-show='!item.edit'
            title="您确定要删除这个版本吗?"
            @confirm="deleteItem(item,index)"
            okText="确定"
            cancelText="取消"
          >
            <a-button class="error" type="link">
              删除
            </a-button>
          </a-popconfirm>
        </div>
      </div>
    </div>
    <a-empty v-if='!data.length' style='margin-top:80px' description='暂时没有版本信息,请点击右上角新增版本添加' @click="addVersion"></a-empty>
  </a-modal>
</template>

<script>
const data = []
export default {
  name: 'version',
  data () {
    return {
      visible: false,
      nowVersion: '1.0',
      data,
      columns: ['版本号', '版本描述', '版本生成时间', '操作'],
      bodyStyle: {
        height: '586px',
        overflow: 'hidden'
      },
      project_id: ''
    }
  },
  watch: {
    visible (val) {
      // mock
      this.project_id = this.$route.query.project_id
      if (val) {
        this.$post('/flow/api/5deb681cfa2f751019537aea', {
          project_id: this.project_id
        }).then(data => {
          this.data = data.list.filter(ver => ver.is_del === '否').reverse()
          this.nowVersion = data.version.number
        })
      }
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hidden () {
      this.visible = false
      this.data = []
    },
    addVersion () {
      this.data.unshift({
        number: '',
        summary: '',
        hex_create_time: new Date().getTime(),
        id: 'id' + new Date().getTime(),
        edit: true
      })
      document.getElementsByClassName('table')[0].scrollTo(0, 0)
    },
    deleteItem (item, index) {
      this.$post('/flow/api/5deb52ec38481d1080bd1f1c', {
        version_id: item._id,
        type: 'delete'
      }).then(data => {
        this.data.splice(index, 1)
        this.$message.success('删除成功')
      })
    },
    edit (item) {
      this.$set(item, 'edit', !item.edit)
      if (item.edit === false) {
        // 新增版本
        if (!item._id) {
          this.$post('/flow/api/5deb42effcfc7a107a392d71', {
            project_id: this.project_id,
            number: item.number,
            summary: item.summary
          }).then(data => {
            this.$message.success('新增成功')
          })
        } else {
          // 修改版本
          this.$post('/flow/api/5deb52ec38481d1080bd1f1c', {
            version_id: item._id,
            number: item.number,
            summary: item.summary,
            type: 'update'
          }).then(data => {
            this.$message.success('更改成功')
          })
        }
      }
    },
    getVersion (item) {
      if (item._id) {
        this.$post('/flow/api/5deb6a4974850d103ffdb68b', {
          project_id: this.project_id,
          version_id: item._id
        }).then(data => {
          this.$post('/flow/api/5deb42effcfc7a107a392d71', {
            project_id: this.project_id,
            number: new Date().toLocaleDateString().slice(5),
            summary: new Date().toLocaleString() + '自动存档'
          }).then(data => {
            this.$message.success('自动存档成功')
          })
          const appId = data.app_id
          const { platformId } = data
          this.$message.success('取档成功')
          this.nowVersion = item.number
          this.$event.$emit('getversion', appId, platformId)
          this.hidden()
        })
      }
    }
  },
  filters: {
    toTime (timeStamp) {
      const time = new Date(timeStamp)
      return time.toLocaleDateString() + ' ' + time.toTimeString().substr(0, 8)
    }
  }
}
</script>

<style lang="less">
.version {
  width: 800px !important;
  height: 640px;
  padding-bottom: 0;
  .ant-modal-content {
    height: 100%;
    .head {
      line-height: 32px;
      &:after {
        display: block;
        clear: both;
        content: "";
      }
      .nowVersion {
        float: left;
      }
      .addButton {
        float: right;
      }
    }
    .table {
      margin-top: 24px;
      line-height: 36px;
      box-sizing: border-box;
      max-height: calc(100% - 48px);
      overflow-y: auto;
      overflow-x: hidden;
      border-top: 1px solid rgba(230, 230, 230, 1);
      border-left: 1px solid rgba(230, 230, 230, 1);
      div {
        box-sizing: border-box;
        word-break: break-all;
      }
      .thead {
        width: 100%;
        background: #fbfbfb;
        font-weight: bold;
      }
      .row {
        display: flex;
        .col {
          padding: 4px 16px;
          width: 98px;
          flex-shrink: 0;
          border-right: 1px solid rgba(230, 230, 230, 1);
          border-bottom: 1px solid rgba(230, 230, 230, 1);
          display: flex;
          align-items: center;
          &:nth-child(2n) {
            width: 287px;
          }
          &:nth-child(3n) {
            width: 176px;
          }
          &:nth-child(4n) {
            width: auto;
            flex-grow: 1;
          }
          button {
            padding: 0 10px;
            margin: auto;
          }
          textarea {
            resize: none;
          }
          .line {
            width: 1px;
            height: 9px;
            display: inline-block;
            background: #e6e6e6;
          }
          .success {
            color: #52c41a;
            padding-left: 0;
          }
          .info {
            color: #1890ff;
          }
          .error {
            color: #f5222d;
          }
        }
      }
    }
  }
}
</style>
